export const STYLES = {
  header: {
    fontSize: 20,
    bold: true,
    margin: [0, 5, 0, 10],
    color: "#000000",
  },
  title: {
    fontSize: 18,
    bold: true,
    margin: [0, 0, 0, 10],
    color: "#000000",
  },
  subtitle: {
    fontSize: 14,
    bold: true,
    margin: [0, 0, 0, 10],
    color: "#000000",
  },
  paragraph: {
    fontSize: 11,
    lineHeight: 1.4,
    textAlign: "justify",
    alignment: "justify",
    margin: [0, 0, 0, 10],
  },
  bulletHeader: {
    bold: true,
    margin: [0, 0, 1, 0],
  },
  graphDescription: {
    fontSize: 9,
    lineHeight: 1.4,
    textAlign: "justify",
    alignment: "justify",
    margin: [0, 0, 0, 0],
  },
  graphDescriptionHeader: {
    fontSize: 9,
    lineHeight: 1.4,
    bold: true,
    textAlign: "center",
    alignment: "center",
    margin: [0, 0, 0, 0],
  },
  list: {
    fontSize: 11,
    marginBottom: 10,
  },
  tableExample: {
    margin: [0, 10, 0, 20],
    fontSize: 10,
  },
  tableHeader: {
    fontSize: 11,
    bold: true,
    color: "#ffffff",
    fillColor: "#42474b",
  },
  tableCell: {
    fontSize: 10,
    color: "#42474b",
    lineHeight: 1.4,
  },
  headerTitle: {
    fontSize: 14,
    bold: true,
    color: "#000000",
  },
  headerPage: {
    fontSize: 10,
    alignment: "right",
    color: "#7f8c8d",
  },
  headerContact: {
    fontSize: 9,
    color: "#7f8c8d",
  },
  footer: {
    fontSize: 8,
    color: "#7f8c8d",
  },
  graphBottom: {
    fontSize: 9,
    lineHeight: 1.4,
    textAlign: "center",
    alignment: "center",
    margin: [0, 0, 0, 0],
  },
  quote: {
    italics: true,
  },
  small: {
    fontSize: 8,
  },
};
